import useConfirmDeleteSus from '@/components/Sus/buttons/useConfirmDeleteSus';
import { ActionIcon, Tooltip } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';

type Props = {
  /** Id du service d'urgence à supprimer. */
  id: number;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  /** Appelé après une suppression réussie (ex. pour fermer le drawer). */
  onDeleted?: () => void;
};

const SusDeleteButton = ({ id, size, onDeleted }: Props) => {
  const { t } = useTranslate();
  const confirmDelete = useConfirmDeleteSus();

  const iconSize =
    size === 'xs' ? 12 : size === 'sm' ? 14 : size === 'md' ? 16 : size === 'lg' ? 18 : 20;

  return (
    <Tooltip label={t('common.delete')} withArrow>
      <ActionIcon
        variant="subtle"
        color="red"
        aria-label={t('common.delete')}
        size={size}
        onClick={() => confirmDelete([id], onDeleted)}
      >
        <IconTrash size={iconSize} stroke={1.5} />
      </ActionIcon>
    </Tooltip>
  );
};

export default SusDeleteButton;
